import retailerFilterTemplate from './retailer-filter.html';

class RetailerFilterDirective {
  constructor() {
    this.restrict = 'E';
    this.template = retailerFilterTemplate;
    this.controller = () => {};
    this.controllerAs = 'ctrl';
  }
}

export default RetailerFilterDirective;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/retailer-filter/retailer-filter-directive.js